import React from 'react';
import AvatarField from '../AvatarField';
import pure from 'recompose/pure';

const FullNameField = ({ record = {}, size }) => {
  if (record != null) {
    return (
      <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
        {record.avatar_url && <AvatarField record={record} size={size} />}
        {record.avatar_url && <span>&nbsp;</span>}
        {record.full_name ? record.full_name : `${record.first_name} ${record.last_name}`}
      </div>
    );
  }
  return null;
};

const PureFullNameField = pure(FullNameField);

PureFullNameField.defaultProps = {
  source: 'full_name',
  label: 'Full Name',
};

export default PureFullNameField;



// WEBPACK FOOTER //
// ./src/components/FullNameField/index.js